import progActions from "./constants";
import * as selectors from "./selectors";

const uuid4 = require("uuid/v4");

const defaultState = {
  streams: [],
  programs: [],
  selected_program: { days: [], id: null },
  selectedStream: { id: null },
  selectedExercise: null,
  selectedDayId: null,
  selectedSeriesId: null,
  selectedExerciseId: null,

  showingCreateProgramModal: false,
  showingEditSeriesModal: false,
  showingCreateSeriesModal: false,
  showingEditDayModal: false,
  showingCreateDayModal: false,
  showingEditProgramModal: false,
  showingCreateStreamModal: false,
  showingEditStreamModal: false,
  showingCreateExerciseModal: false,
  showingEditExerciseModal: false,
  showingEditAddedExerciseModal: false,
  showingProgressionExerciseModal: false,
  showingPublishingModal: false,
  showingTeamModal: false,
  clipboardDay: null,
  clipboardSeries: null,
  clipboardProgram: null,
  visual_filter_by: "program",
  switch_filter_assigned_to_all: true,
  switch_filter_athlete_specific: false,
};

function generateCards(day) {
  const exercises = [];
  const cards = day.entities.map((entity, index) => {
    entity.exercises.map((ex) => {
      exercises.push({ text: ex.name, id: uuid4(), card_id: index });
    });
    return { id: index, title: entity.entity_id };
  });
  return {
    cards,
    exercises,
  };
}

export default function programming(state = defaultState, action) {
  let index,
    newstate,
    streams,
    new_state,
    full_program,
    showingEditProgramModal,
    programs;

  switch (action.type) {
    case progActions.FETCH_STREAMS_SUCCESS:
      streams = action.payload.streams;
      return {
        ...state,
        streams: [...streams],
      };
    case progActions.FETCH_PROGRAMS_SUCCESS:
      return {
        ...state,
        programs: action.payload,
        backup_programs: action.payload,
        switch_filter_assigned_to_all: false,
        switch_filter_athlete_specific: false,
      };
    case progActions.PATCH_DAYS:
      new_state = {
        ...state,
        selected_program: { ...state.selected_program, days: action.payload },
      };
      return new_state;
    case progActions.SELECT_STREAM:
      return {
        ...state,
        selectedStream: action.payload.streamId,
      };
    case progActions.SET_PROGRAM:
      return {
        ...state,
        program: action.payload,
      };
    case progActions.ADD_CARD:
      newstate = {
        ...state,
        program: { ...state.program, cards: action.payload },
      };
      return newstate;
    case progActions.PROGRAMMING_ADD_EXERCISE:
      newstate = {
        ...state,
        program: { ...state.program, exercises: action.payload },
      };
      // console.log("newstate", newstate);
      return newstate;
    case progActions.FETCH_FULL_PROGRAM_SUCCESS:
      full_program = action.payload.full_program;

      showingEditProgramModal = {};
      if (action.showingEditProgramModal)
        showingEditProgramModal = { showingEditProgramModal: true };
      return {
        ...state,
        ...showingEditProgramModal,
        selected_program: {
          ...action.payload.full_program,
          days: action.payload.full_program.days.sort(function(a, b) {
            return a.day_number > b.day_number;
          }),
        },
      };

    case progActions.CLEAR_SELECTED_DAY:
      return { ...state, selectedDayId: null };
    case progActions.ACTIVATE_DAY:
      return {
        ...state,
        selectedDayId: action.payload,
      };
    case progActions.ADD_NEW_DAY:
      return {
        ...state,
        selected_program: action.payload.selected_program,
      };
    case progActions.SHOW_CREATE_PROGRAM_MODAL:
      return {
        ...state,
        showingCreateProgramModal: true,
      };

    case progActions.HIDE_CREATE_PROGRAM_MODAL:
      return {
        ...state,
        showingCreateProgramModal: false,
      };
    case progActions.SHOW_EDIT_PROGRAM_MODAL_SUCESS:
      return {
        ...state,
        showingEditProgramModal: true,
      };
    case progActions.HIDE_EDIT_PROGRAM_MODAL:
      return {
        ...state,
        showingEditProgramModal: false,
      };
    case progActions.SHOW_EDIT_SERIES_MODAL:
      return {
        ...state,
        showingEditSeriesModal: true,
      };

    case progActions.HIDE_EDIT_SERIES_MODAL:
      return {
        ...state,
        showingEditSeriesModal: false,
      };
    case progActions.SHOW_CREATE_SERIES_MODAL:
      return {
        ...state,
        selectedSeriesId: uuid4(),
        showingCreateSeriesModal: true,
      };
    case progActions.HIDE_CREATE_SERIES_MODAL:
      return {
        ...state,
        showingCreateSeriesModal: false,
      };
    case progActions.SHOW_EDIT_DAY_MODAL:
      return {
        ...state,
        showingEditDayModal: true,
      };
    case progActions.HIDE_EDIT_DAY_MODAL:
      return {
        ...state,
        showingEditDayModal: false,
      };
    case progActions.CREATE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: [...state.programs, action.payload],
        selected_program: action.payload,
      };
    case progActions.ACTIVATE_SERIES:
      return {
        ...state,
        selectedSeriesId: action.payload,
      };
    case progActions.ACTIVATE_STREAM:
      return {
        ...state,
        selectedStream: action.payload,
        visual_filter_by: "stream",
        selected_program: { id: null, days: [] },
      };
    case progActions.PATCH_PROGRAM_SUCCESS:
      programs = [...state.programs];
      programs = programs.filter((p) => p.id !== action.payload.id);
      programs.push({ ...action.payload });
      programs = programs.sort((a, b) =>
        a.created_on > b.created_on ? -1 : 1
      );
      // console.log('programs from patch success', programs)
      // console.log("patching state is", programs);
      return {
        ...state,
        // selected_program: action.payload,
        programs,
      };
    case progActions.PATCH_STREAM_SUCCESS:
      return {
        ...state,
        selectedStream: action.payload,
      };

    case progActions.SHOW_CREATE_STREAM_MODAL:
      return {
        ...state,
        showingCreateStreamModal: true,
      };
    case progActions.HIDE_CREATE_STREAM_MODAL:
      return {
        ...state,
        showingCreateStreamModal: false,
      };

    case progActions.SHOW_EDIT_STREAM_MODAL:
      return {
        ...state,
        showingEditStreamModal: true,
      };
    case progActions.HIDE_EDIT_STREAM_MODAL:
      return {
        ...state,
        showingEditStreamModal: false,
      };
    case progActions.DEACTIVATE_PROGRAMS:
      return {
        ...state,
        selected_program: { days: [] },
        selectedDayId: null,
        selectedSeriesId: null,
        visual_filter_by: "program",
      };
    case progActions.DEACTIVATE_STREAM:
      return {
        ...state,
        selectedStream: { id: null },
        visual_filter_by: "program",
      };
    case progActions.SHOW_CREATE_EXERCISE_MODAL:
      return {
        ...state,
        showingCreateExerciseModal: true,
      };
    case progActions.HIDE_CREATE_EXERCISE_MODAL:
      return {
        ...state,
        showingCreateExerciseModal: false,
      };
    case progActions.SHOW_EDIT_EXERCISE_MODAL:
      return {
        ...state,
        showingEditExerciseModal: true,
      };
    case progActions.HIDE_EDIT_EXERCISE_MODAL:
      return {
        ...state,
        showingEditExerciseModal: false,
      };
    case progActions.SELECT_EXERCISE:
      return {
        ...state,
        selectedExercise: action.payload,
      };
    case progActions.SHOW_CREATE_DAY_MODAL:
      return {
        ...state,
        showingCreateDayModal: true,
      };
    case progActions.HIDE_CREATE_DAY_MODAL:
      return {
        ...state,
        showingCreateDayModal: false,
      };
    case progActions.CLIPBOARD_DAY:
      return {
        ...state,
        clipboardDay: action.payload,
      };
    case progActions.CLIPBOARD_SERIES:
      return {
        ...state,
        clipboardSeries: action.payload,
      };

    case progActions.SHOW_EDIT_ADDED_EXERCISE_MODAL:
      return {
        ...state,
        showingEditAddedExerciseModal: true,
        handle_change: action.handle_change,
        selected_exercises: action.exercises,
      };
    case progActions.SHOW_CREATE_PROGRESSION_EXERCISE:
      return {
        ...state,
        showingProgressionExerciseModal: true,
      };
    case progActions.HIDE_CREATE_PROGRESSION_EXERCISE:
      return {
        ...state,
        showingProgressionExerciseModal: false,
      };

    case progActions.HIDE_EDIT_ADDED_EXERCISE_MODAL:
      return {
        ...state,
        showingEditAddedExerciseModal: false,
      };
    case progActions.ACTIVATE_EXERCISE:
      return {
        ...state,
        selectedExerciseId: action.payload.id,
      };
    case progActions.SET_THIS_PAYLOAD:
      // console.log("before returning from reducer", action.payload);
      return {
        ...state,
        ...action.payload,
      };
    case progActions.PATCH_PROGRESSION_DAY:
      newstate = { ...state };
      index = newstate.selected_program.days.findIndex(
        (d) => d.id === newstate.selectedDayId
      );
      newstate.selected_program.days[index] = action.payload;
      // console.log("returning this state", newstate);
      return {
        ...state,
        selected_program: { ...newstate.selected_program },
        showingProgressionExerciseModal: false,
      };
    case progActions.SHOW_PUBLISHING_MODAL:
      return {
        ...state,
        showingPublishingModal: true,
      };
    case progActions.HIDE_PUBLISHING_MODAL:
      return {
        ...state,
        showingPublishingModal: false,
      };
    case progActions.SET_SELECTED_PROGRAM:
      return { ...state, selected_program: action.payload };
    case progActions.SHOW_TEAM_MODAL:
      return { ...state, showingTeamModal: action.payload };
    case progActions.PATCH_STREAMS:
      streams = [...state.streams];
      streams = streams.filter((s) => s.id !== action.payload.id);
      streams.push(action.payload);
      streams = streams.sort((a, b) =>
        a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
      );
      return { ...state, streams };
    default:
      return state;
  }
}

export const getCards = (state) => state.program.cards;
export const getExercises = (state) => state.program.exercises;
